// @flow
import createMaybeTransform from 'app/common/react/components/closeup/utils/createMaybeTransform';
import type {
  HasImages,
  HasPin,
  MaybeAToMaybeAB,
} from 'app/common/react/components/closeup/utils/types';

type ToMaybeHasImages = MaybeAToMaybeAB<HasPin, HasImages>;

const hasImages: ToMaybeHasImages = createMaybeTransform((props) => {
  const { pin } = props,
    { images } = pin,
    validatedImages = Object.keys(images || {}).reduce((out, imageKey) => {
      const imageData = images[imageKey],
        { url, width, height } = imageData;
      return out && url && width && height ? { ...out, [imageKey]: { url, width, height } } : null;
    }, {});
  return validatedImages && Object.keys(validatedImages).length > 0
    ? {
        ...props,
        images: validatedImages,
      }
    : null;
});

export default hasImages;
